import Controller from './application_controller'

/**
 * Adds some extra functionality to form elements.
 *
 * 1. Rejects form submissions when the form is already submitting.
 *
 * data-submitting:
 *   Set when a form starts a submission, and cleared when the submission is complete.
 *
 */
export default class TurboFormController extends Controller {
  connect() {
    this.addEventListener('submit', this.submit.bind(this))
    this.addEventListener('turbo:submit-start', e => this.submitting = true)
    this.addEventListener('turbo:submit-end', e => this.submitting = false)
  }

  get submitting() {
    return this.element.hasAttribute('data-submitting')
  }

  set submitting(value) {
    if (value) {
      this.element.setAttribute('data-submitting', 'true')
    } else {
      this.element.removeAttribute('data-submitting')
    }
  }

  submit(event) {
    if (this.submitting) {
      event.preventDefault()
    }
  }
}